import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 6000 }
  }

  connect() {
    // Start off-screen, then slide in on the next frame
    this.element.style.transform = "translateX(calc(100% + 1rem))"
    this.element.style.opacity = "0"
    this.element.style.transition = "transform 0.35s cubic-bezier(0.21, 1.02, 0.73, 1), opacity 0.35s ease"

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.transform = "translateX(0)"
        this.element.style.opacity = "1"
      })
    })

    // Auto-dismiss after duration
    this.autoCloseTimer = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer)
    }
  }

  dismiss() {
    if (this.isDismissing) return
    this.isDismissing = true

    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer)
    }

    // Slide out to the right
    this.element.style.transition = "transform 0.3s cubic-bezier(0.4, 0, 1, 1), opacity 0.3s ease"
    this.element.style.transform = "translateX(calc(100% + 1rem))"
    this.element.style.opacity = "0"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
